import React from 'react';
import conferenceStand from '../../assets/images/about/conference-stand.jpg';
import standBuild from '../../assets/images/about/stand-build.jpg';
import whiteboard from '../../assets/images/about/whiteboard.jpg';

// Photos from the previous drive.day/about-us gallery
const PHOTOS = [
    { src: conferenceStand, alt: 'The Drive.Day stand ready for the Intelligent Instructor Conference' },
    { src: standBuild, alt: 'Building the Drive.Day stand at a conference' },
    { src: whiteboard, alt: 'Planning a new feature on the whiteboard' },
];

function GalleryAbout() {
    return (
        <section className="dd-about-gallery pt-100 pb-100">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="dd-section-title text-center">
                            <h3 className="dd-title">Gallery</h3>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {PHOTOS.map((photo) => (
                        <div className="col-lg-4 col-md-4" key={photo.src}>
                            <div className="dd-about-gallery-item">
                                <img src={photo.src} alt={photo.alt} loading="lazy" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default GalleryAbout;
